import angular from 'angular';
import addedtoCartModalComponent from './addedToCartModal.component';
import voziqOfferModalComponent from './shopVoziqOfferModal.component'
import modalsModule from 'portal/common/modals';


export default angular.module('fp:customerportal:shop:product:modals',
        [
            modalsModule.name
        ])
    .component('fpAddedToCartModal', addedtoCartModalComponent)
    .component('fpShopVoziqOfferModal', voziqOfferModalComponent);
